/*--------------------------------------------------------------
# Custom scripts for FAQs block
--------------------------------------------------------------*/

// let accordionItemsToBeFocused = document.querySelectorAll(".accordion-collapse");

// accordionItemsToBeFocused.forEach((el)=>{
//     el.addEventListener('shown.bs.collapse',(e)=>{
//         window.location.href = '#' + el.id
//     })
// })

document.addEventListener('shown.bs.collapse', (e) => {
    const closestAccordion = e.target.closest('.accordion-collapse');
    
    if (closestAccordion) {
        window.location.href = '#' + closestAccordion.id;
    }
});